export const ROOT_DIR = {
  root: true,
  id: '0',
  name: 'api.panel.questionnaire_templates.modal_title',
};
